const LATENCY_MS = 400;
const delay = value => new Promise(resolve => setTimeout(() => resolve(value), LATENCY_MS));
function seedNotifications() {
  const items = [];
  const now = Date.now();
  const HOUR = 3600000;
  for (let i = 0; i < 23; i += 1) {
    const type = i % 2 === 0 ? 'BILLING' : 'DEALS';
    items.push({
      notificationId: i + 1,
      notificationType: type,
      title: `Notification ${i + 1}`,
      body: `This is the detail body for notification ${i + 1}. It explains what happened and why you are seeing it.`,
      notificationLink: `/portal/notifications/${i + 1}`,
      createdAt: now - i * 5 * HOUR,
      isRead: i % 3 === 0
    });
  }
  return items;
}
let store = seedNotifications();
function countUnread() {
  return store.filter(n => !n.isRead).length;
}

// 1. getNotifications - paginated fetch, optionally filtered by type.
export function getNotifications({
  offset,
  limit,
  notificationType
}) {
  const filtered = notificationType ? store.filter(n => n.notificationType === notificationType) : store;
  const page = filtered.slice(offset, offset + limit);
  return delay({
    notifications: page,
    totalCount: filtered.length,
    unreadCount: countUnread()
  });
}

// 2. markNotificationAsRead - empty response, mirrors real RPC.
export function markNotificationAsRead({
  notificationId
}) {
  store = store.map(n => n.notificationId === notificationId ? Object.assign({}, n, {
    isRead: true
  }) : n);
  return delay({});
}

// 3. markAllNotificationsAsRead - returns how many were flipped.
export function markAllNotificationsAsRead() {
  const updatedCount = countUnread();
  store = store.map(n => n.isRead ? n : Object.assign({}, n, {
    isRead: true
  }));
  return delay({
    updatedCount
  });
}

// 4. deleteNotification - removes from the store.
export function deleteNotification({
  notificationId
}) {
  store = store.filter(n => n.notificationId !== notificationId);
  return delay({});
}

// Test helper: reset the in-memory store between specs.
export function __resetMockNotifications() {
  store = seedNotifications();
}